import { render, staticRenderFns } from "./security_shifts.vue?vue&type=template&id=b9b5711c&scoped=true"
import script from "./security_shifts.vue?vue&type=script&lang=js"
export * from "./security_shifts.vue?vue&type=script&lang=js"
import style0 from "./security_shifts.vue?vue&type=style&index=0&id=b9b5711c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b5711c",
  null
  
)

export default component.exports